var SamplerState = /** @class */ (function () {
    function SamplerState(id, type, wrap, filter, mipfilter) {
        if (id === void 0) { id = -1; }
        if (type === void 0) { type = null; }
        if (wrap === void 0) { wrap = 0; }
        if (filter === void 0) { filter = 0; }
        if (mipfilter === void 0) { mipfilter = 0; }
        this.id = id;
        this.type = type;
        this.wrap = wrap;
        this.filter = filter;
        this.mipfilter = mipfilter;
        this.boundedTexture = null;
    }
    Object.defineProperty(SamplerState.prototype, "valid", {
        get: function () {
            return this.type !== null && this.id >= 0;
        },
        enumerable: false,
        configurable: true
    });
    SamplerState.prototype.equals = function (s) {
        return (this.type === s.type &&
            this.wrap === s.wrap &&
            this.filter === s.filter &&
            this.mipfilter === s.mipfilter);
    };
    SamplerState.prototype.copyFrom = function (s) {
        this.type = s.type;
        this.wrap = s.wrap;
        this.filter = s.filter;
        this.mipfilter = s.mipfilter;
        return this;
    };
    SamplerState.prototype.dispose = function () {
        this.id = -1;
        this.type = null;
        this.wrap = 0;
        this.filter = 0;
        this.mipfilter = 0;
    };
    return SamplerState;
}());
export { SamplerState };
